
import React from "react";
import { Link } from "react-router-dom";

const btesLogoUrl = "/btes-logo.png";

const NavbarLogo = () => {
  return (
    <Link to="/" className="flex items-center gap-2 text-xl font-display font-semibold">
      <img
        src={btesLogoUrl}
        alt="BlueTech Logo"
        className="w-8 h-8 object-contain"
        loading="eager"
        width="32"
        height="32"
      />
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent dark:from-primary dark:to-accent">BlueTech</span>
    </Link>
  );
};

export default NavbarLogo;
